module.exports = __webpack_public_path__ + "img/wein-kulinarik-desktop.7da1b470.jpg";